import type { JSX, ReactNode } from 'react';

export interface MetricTileProps {
  label: string;
  value: ReactNode;
  detail?: string;
}

export function MetricTile({ detail, label, value }: MetricTileProps): JSX.Element {
  return (
    <article className="fui-metric-tile">
      <span>{label}</span>
      <strong>{value}</strong>
      {detail === undefined ? null : <small>{detail}</small>}
    </article>
  );
}
